// extracted by mini-css-extract-plugin
export default {"settings-card-info__toggle":"ToggleCard_settings-card-info__toggle__67X0S","settings-card-info__toggle-text":"ToggleCard_settings-card-info__toggle-text__y5MvT"};